import { addDays, format } from 'date-fns';
import { IGerarRemessaSicoob } from './types';
import { Arquivo } from '@/lib/Arquivo';
import { removerCaracterEspecial } from "@/utils/removerCaracterEspecial";

export function gerarRemessa({ dados }: IGerarRemessaSicoob) {
  try {
    const { dadosBancario, beneficiario, boletos } = dados.remessa;

    const arquivo = new Arquivo();
    const dataAtual = new Date();
    const data = format(dataAtual, 'ddMMyyyy');
    const hora = format(dataAtual, 'HHmmss');

    const remessa = `REM${dadosBancario.numeroRemessa.padStart(6, '0')}.REM`;

    // Header do arquivo
    arquivo.add('756');
    arquivo.add('0000');
    arquivo.add('0');
    arquivo.add(' '.padEnd(9, ' '));
    arquivo.add('2');
    arquivo.add(beneficiario.cnpj);
    arquivo.add(' '.padEnd(20, ' '));
    arquivo.add(dadosBancario.agencia.padStart(5, '0'));
    arquivo.add(dadosBancario.agenciaDigito);
    arquivo.add(dadosBancario.conta.padStart(12, '0'));
    arquivo.add(dadosBancario.contaDigito);
    arquivo.add('0');
    arquivo.add(removerCaracterEspecial(beneficiario.nome).substring(0, 30).padEnd(30, ' '));
    arquivo.add('SICOOB'.padEnd(30, ' '));
    arquivo.add(' '.padEnd(10, ' '));
    arquivo.add('1');
    arquivo.add(data);
    arquivo.add(hora);
    arquivo.add(dadosBancario.numeroRemessa.padStart(6, '0'));
    arquivo.add('081');
    arquivo.add('00000');
    arquivo.add(' '.padEnd(69, ' '));

    arquivo.addLine();

    // Header do lote
    arquivo.add('756');
    arquivo.add('0001');
    arquivo.add('1');
    arquivo.add('R');
    arquivo.add('01');
    arquivo.add('  ');
    arquivo.add('040');
    arquivo.add(' ');
    arquivo.add('2');
    arquivo.add(beneficiario.cnpj.padStart(15, '0'));
    arquivo.add(' '.padEnd(20, ' '));
    arquivo.add(dadosBancario.agencia.padStart(5, '0'));
    arquivo.add(dadosBancario.agenciaDigito);
    arquivo.add(dadosBancario.conta.padStart(12, '0'));
    arquivo.add(dadosBancario.contaDigito);
    arquivo.add(' ');
    arquivo.add(removerCaracterEspecial(beneficiario.nome).substring(0, 30).padEnd(30, ' '));
    arquivo.add(' '.padEnd(80, ' '));
    arquivo.add(dadosBancario.numeroRemessa.padStart(8, '0'));
    arquivo.add(data);
    arquivo.add('00000000');
    arquivo.add(' '.padEnd(33, ' '));

    arquivo.addLine();

    let sequencia = 0;
    let quantidadeRegistro = 0;
    let total = 0;

    // Registro Detalhe – Segmento P
    for (const boleto of boletos) {
      const { pagador } = boleto;
      const vencimento = format(new Date(boleto.vencimento), 'ddMMyyyy');
      const valor_juros_dia = Number(boleto.valor) * dadosBancario.jurosMes / 100 / 30;
      let protesto = '3';
      switch (dadosBancario.tipo_protesto) {
        case 'Nenhum':
          protesto = '3';
          break;
        case 'Protestar':
          protesto = '1';
          break;
        case 'Negativar':
          protesto = '8';
          break;
      }
      const diasProtesto = dadosBancario.diasProtesto.toString().padStart(2, '0');
      total += Number(boleto.valor);

      arquivo.add('756');
      arquivo.add('0001');
      arquivo.add('3');
      arquivo.add((++sequencia).toString().padStart(5, '0'));
      arquivo.add('P');
      arquivo.add(' ');
      arquivo.add('01');
      arquivo.add(dadosBancario.agencia.padStart(5, '0'));
      arquivo.add(dadosBancario.agenciaDigito);
      arquivo.add(dadosBancario.conta.padStart(12, '0'));
      arquivo.add(dadosBancario.contaDigito);
      arquivo.add(' ');
      arquivo.add(boleto.nossoNumero.padStart(10, '0'));
      arquivo.add(boleto.parcela.toString().padStart(2, '0'));
      arquivo.add(dadosBancario.modalidade.padStart(2, '0'));
      arquivo.add('6');
      arquivo.add(' '.padEnd(5, ' '));
      arquivo.add(dadosBancario.carteira);
      arquivo.add('0 22');
      arquivo.add(`${boleto.numeroDocumento}/${Number(boleto.parcela)}`.padEnd(15, ' '));
      arquivo.add(vencimento);
      arquivo.add(Number(boleto.valor).toFixed(2).replace('.', '').padStart(15, '0'));
      arquivo.add('00000');
      arquivo.add(' ');
      arquivo.add('02'); // especie
      arquivo.add(boleto.aceite); // aceite
      arquivo.add(data);
      arquivo.add('1');
      arquivo.add(format(addDays(new Date(boleto.vencimento), 1), 'ddMMyyyy'));
      arquivo.add(valor_juros_dia.toFixed(2).replace('.', '').padStart(15, '0'));
      arquivo.add('0');
      arquivo.add('00000000');
      arquivo.add('000000000000000');
      arquivo.add('000000000000000');
      arquivo.add('000000000000000');
      arquivo.add(boleto.identificacaoTitulo.padEnd(25, ' ')); // Identificação de título, usar depois
      arquivo.add(protesto);
      arquivo.add(diasProtesto);
      arquivo.add('0');
      arquivo.add('   ');
      arquivo.add('09');
      arquivo.add('0000000000');
      arquivo.add(' ');

      arquivo.addLine();

      // Registro Detalhe – Segmento Q
      let tipoInscricao = '1';

      if (pagador.pessoa === 'F') {
        tipoInscricao = '1';
      } else {
        tipoInscricao = '2';
      }

      pagador.endereco.logradouro = `${
        removerCaracterEspecial(pagador.endereco.logradouro)
        .substring(0, 32)
        .padEnd(32, ' ')}${pagador.endereco.numero.padEnd(8, ' ')}`;

      arquivo.add('756');
      arquivo.add('0001');
      arquivo.add('3');
      arquivo.add((++sequencia).toString().padStart(5, '0'));
      arquivo.add('Q');
      arquivo.add(' ');
      arquivo.add('01');
      arquivo.add(tipoInscricao);
      arquivo.add(pagador.cpfCnpj.padStart(15, '0'));
      arquivo.add(removerCaracterEspecial(pagador.nome).substring(0, 40).padEnd(40, ' '));
      arquivo.add(removerCaracterEspecial(pagador.endereco.logradouro).substring(0, 40).padEnd(40, ' '));
      arquivo.add(removerCaracterEspecial(pagador.endereco.bairro).substring(0, 15).padEnd(15, ' '));
      arquivo.add(pagador.endereco.cep.padEnd(8, ' '));
      arquivo.add(removerCaracterEspecial(pagador.endereco.municipio).substring(0, 15).padEnd(15, ' '));
      arquivo.add(removerCaracterEspecial(pagador.endereco.uf).padEnd(2, ' '));
      arquivo.add('0');
      arquivo.add('000000000000000');
      arquivo.add(' '.padEnd(40, ' '));
      arquivo.add('000');
      arquivo.add(' '.padEnd(28, ' '));

      arquivo.addLine();

      // Registro Detalhe – Segmento R

      let multa = '0';
      let data_multa = '00000000';
      let valor_multa = '000000000000000';

      dadosBancario.multaAtraso = Number(dadosBancario.multaAtraso || 0);
      if (dadosBancario.multaAtraso > 0) {
        multa = '2';
        data_multa = format(addDays(new Date(boleto.vencimento), 1), 'ddMMyyyy');
        valor_multa = dadosBancario.multaAtraso.toFixed(2).replace('.', '').padStart(15, '0');
      }

      arquivo.add('756');
      arquivo.add('0001');
      arquivo.add('3');
      arquivo.add('');
      arquivo.add((++sequencia).toString().padStart(5, '0'));
      arquivo.add('R');
      arquivo.add(' ');
      arquivo.add('01');
      arquivo.add('0');
      arquivo.add('00000000');
      arquivo.add('000000000000000');
      arquivo.add('0');
      arquivo.add('00000000');
      arquivo.add('000000000000000');
      arquivo.add(multa);
      arquivo.add(data_multa);
      arquivo.add(valor_multa);
      arquivo.add(' '.padEnd(10, ' '));
      arquivo.add(' '.padEnd(40, ' '));
      arquivo.add(' '.padEnd(40, ' '));
      arquivo.add(' '.padEnd(20, ' '));
      arquivo.add('00000000');
      arquivo.add('000');
      arquivo.add('00000');
      arquivo.add(' ');
      arquivo.add('000000000000');
      arquivo.add('  ');
      arquivo.add('0');
      arquivo.add(' '.padEnd(9, ' '));

      arquivo.addLine();
      quantidadeRegistro++;
    }

    // Registro trailer do lote
    arquivo.add('756');
    arquivo.add('0001');
    arquivo.add('5');
    arquivo.add(' '.padEnd(9, ' '));
    arquivo.add((sequencia + 2).toString().padStart(6, '0'));
    arquivo.add(quantidadeRegistro.toString().padStart(6, '0'));
    arquivo.add('00');
    arquivo.add(total.toFixed(2).replace('.', '').padStart(15, '0'));
    arquivo.add('000000000000000000000000000000000000000000000000000000000000000000000');
    arquivo.add(' '.padEnd(125, ' '));

    arquivo.addLine();

    arquivo.add('756');
    arquivo.add('9999');
    arquivo.add('9');
    arquivo.add(' '.padEnd(9, ' '));
    arquivo.add('000001');
    arquivo.add((sequencia + 4).toString().padStart(6, '0'));
    arquivo.add('000000');
    arquivo.add(' '.padEnd(205, ' '));

    return {
      download: remessa,
      arquivo: arquivo.getArquivo(),
    };
  } catch (error) {
    console.log(error);
    return null;
  }
}
